/** @format */

import React, { Component, Suspense } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { store } from '../../core/store';
import { geoLocationStateReducers } from '../../modules/getlocationstate/reducers';

function Translate(props) {
    const { t, trans, valueObject } = props;
    if (valueObject) {
        return t(trans, valueObject);
    }
    return t(trans);
}

class I18n extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadedTranslations: [],
        };
    }

    render() {
        const { trans, file, asterisk, valueObject } = this.props;
        if (!trans || trans === '') {
            return <Suspense fallback="..." />;
        }

        if (!trans.includes(':')) {
            return trans;
        }

        const availableTranslations = [
            'translation',
            'error',
            'pools',
            'simcard',
            'clients',
            'documents',
            'platform_reseller',
            'platform_user',
            'tariffs',
            'prov',
            'general',
            'auth',
            'billing_imports',
            'billing',
            'mnp_cases',
            'tariffing',
            'number_range',
            'service_code',
            'permission_groups',
            'pricelists',
            'prefixes',
            'reports',
            'specialized_report',
            'discount',
            'fractions',
            'retarification',
            'notifications',
            'services_activation',
        ];

        let arr = [];
        const requestedTranslation = trans.substring(0, trans.indexOf(':'));
        if (!this.state.loadedTranslations.includes(requestedTranslation) && availableTranslations.includes(requestedTranslation)) {
            this.setState({ loadedTranslations: [...this.state.loadedTranslations, requestedTranslation] });
            arr = [...this.state.loadedTranslations, requestedTranslation];
        } else {
            arr = this.state.loadedTranslations;
        }

        if (file && file !== '') {
            arr = file();
        }
        const TranslateComponent = withTranslation(arr)(Translate);
        return (
            <Suspense fallback="...">
                <TranslateComponent trans={trans} valueObject={valueObject} /> {asterisk ? '*' : null}
            </Suspense>
        );
    }
}

I18n.propTypes = {
    trans: PropTypes.string,
    file: PropTypes.func,
    asterisk: PropTypes.bool,
    valueObject: PropTypes.object,
};

export default I18n;
